/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".order-btn[_ngcontent-%COMP%]{letter-spacing:.5px;height:20px;line-height:20px;border-radius:10px;padding:0 6px}.order-label[_ngcontent-%COMP%]{margin-right:6px;color:#b5becb}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/discover/order-bar/order-bar.component.scss.shim.ngstyle.js.pre-build-optimizer.js